import { useState } from 'react'
import { useSelector } from 'react-redux'

import styles from './ManageEnterprises.module.scss'

import { BillingProvider } from '@/api/generated'
import Button from '@/components/Button'
import { useEnterpriseDetails } from '@/hooks/useEnterpriseDetails'
import ConvertToSalesOwnedDialog from '@/pages/app/Enterprises/components/ManageEnterprises/ConvertToSalesOwnedDialog'
import { selectIsInternalAdmin } from '@/store/features/user/userSlice'

const PROVIDER_LABELS: Record<BillingProvider, string> = {
  stripe: 'Stripe',
  self_serve: 'Self-serve (Stripe)',
  sales_owned: 'Sales-owned',
  sequence: 'Sequence',
}

const TIER_LABELS = { enterprise: 'Enterprise', business: 'Growth' } as const

const CONVERTIBLE_PROVIDERS: BillingProvider[] = [BillingProvider.Stripe, BillingProvider.SelfServe]

interface EnterpriseBillingStatusProps {
  enterpriseId: string
}

const EnterpriseBillingStatus = ({ enterpriseId }: EnterpriseBillingStatusProps) => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [isConvertOpen, setIsConvertOpen] = useState(false)
  const { data } = useEnterpriseDetails(enterpriseId)
  const details = data?.data
  if (!details) return null

  const provider = details.billing_provider ?? null
  const costCenterId = details.general_cost_center_id ?? null
  const canConvert =
    isInternalAdmin && costCenterId !== null && provider !== null && CONVERTIBLE_PROVIDERS.includes(provider)

  return (
    <div className={styles.billingBadges}>
      <span className={styles.billingBadge}>{provider ? PROVIDER_LABELS[provider] : 'No billing'}</span>
      {provider && (
        <span className={styles.billingBadge}>
          {details.plan_tier ? TIER_LABELS[details.plan_tier] : 'Team / no live plan'}
        </span>
      )}
      {canConvert && <Button title="Convert to sales-owned" type="light" onClick={() => setIsConvertOpen(true)} />}
      {isConvertOpen && costCenterId && (
        <ConvertToSalesOwnedDialog
          enterpriseId={enterpriseId}
          costCenterId={costCenterId}
          close={() => setIsConvertOpen(false)}
        />
      )}
    </div>
  )
}

export default EnterpriseBillingStatus
